module.exports = __webpack_public_path__ + "img/collection-diamondJewelryPresentsMother@2x.e120cd9.jpg";